import { ListItem, Typography, Checkbox, Stack, Tooltip, IconButton } from '@mui/material';
import PropTypes from 'prop-types';
import EditIcon from '@mui/icons-material/EditOutlined';
import MergeIcon from '@mui/icons-material/Merge';
import ArchiveIcon from '@mui/icons-material/Archive';
import UnarchiveIcon from '@mui/icons-material/Unarchive';
import { useArchiveItem } from './Hooks/useArchiveItem';
import isTargetMergingItem from '../../shared/functions/isSelectedContact';

const EnumListItem = ({
  targetMergingItem,
  enumItem,
  itemType,
  isMerging,
  selectedItems,
  handleCheckboxChange,
  setIsEditing,
  setSelectedEnum,
  setEnumModalOpen,
  setIsMerging,
  isArchivedItem,
}) => {
  const archiveItemMutation = useArchiveItem(enumItem, itemType);

  const handleArchiveClick = async () => {
    await archiveItemMutation.mutateAsync();
  };

  const shouldBeDisabled = isTargetMergingItem(targetMergingItem, enumItem);
  const campaignTooltip = typeof enumItem.tooltip === 'string' ? enumItem.tooltip.trim() : '';
  const itemLabel = campaignTooltip ? (
    <Tooltip title={campaignTooltip} placement="right">
      <Typography>{enumItem.name}</Typography>
    </Tooltip>
  ) : (
    <Typography>{enumItem.name}</Typography>
  );

  return (
    <ListItem
      divider={true}
      sx={{
        alignContent: 'space-between',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: enumItem.backgroundColor,
      }}
      disabled={shouldBeDisabled}
    >
      {itemLabel}
      {isMerging ? (
        <Checkbox checked={selectedItems.has(enumItem)} onChange={(event) => handleCheckboxChange(event, enumItem)} disabled={shouldBeDisabled} />
      ) : (
        <Stack direction={'row'} sx={{ alignContent: 'center', alignItems: 'center', marginLeft: '5%' }}>
          <Tooltip title="Edit">
            <IconButton
              size="small"
              onClick={() => {
                setIsEditing(true);
                setSelectedEnum(enumItem);
                setEnumModalOpen(true);
              }}
            >
              <EditIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Merge">
            <IconButton
              size="small"
              onClick={() => {
                setSelectedEnum(enumItem);
                setIsMerging(true);
              }}
            >
              <MergeIcon />
            </IconButton>
          </Tooltip>
          {isArchivedItem ? (
            <Tooltip title="Unarchive">
              <IconButton size="small" onClick={handleArchiveClick}>
                <UnarchiveIcon />
              </IconButton>
            </Tooltip>
          ) : (
            <Tooltip title="Archive">
              <IconButton size="small" onClick={handleArchiveClick}>
                <ArchiveIcon />
              </IconButton>
            </Tooltip>
          )}
        </Stack>
      )}
    </ListItem>
  );
};

EnumListItem.propTypes = {
  targetMergingItem: PropTypes.object,
  enumItem: PropTypes.shape({
    _id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string.isRequired,
    backgroundColor: PropTypes.string,
    tooltip: PropTypes.string,
  }).isRequired,
  itemType: PropTypes.string.isRequired,
  isMerging: PropTypes.bool.isRequired,
  selectedItems: PropTypes.instanceOf(Set).isRequired,
  handleCheckboxChange: PropTypes.func.isRequired,
  setIsEditing: PropTypes.func.isRequired,
  setSelectedEnum: PropTypes.func.isRequired,
  setEnumModalOpen: PropTypes.func.isRequired,
  setIsMerging: PropTypes.func.isRequired,
  isArchivedItem: PropTypes.bool,
};

EnumListItem.defaultProps = {
  targetMergingItem: null,
  isArchivedItem: false,
};

export default EnumListItem;
